import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import Skeleton from '@material-ui/lab/Skeleton';
import clsx from 'clsx';
import { propStr } from '../../../../../../../../../helpers/custom-prop-types';
import { useArrayWithIndex } from '../../../../../../../../../helpers/use/useArray';
import TagIcon from '../../../../../../../../Icon/Svg/TagIcon';
/**
 * Prpffit Searchの人気タグ一覧のスケルトンを表示するコンポーネント
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const ProfessionalMyPageTopProffitSearchSlideTagsContentSkeleton = (props) => {
    const { className } = props;
    const dummies = useArrayWithIndex(8);
    return (_jsx("div", Object.assign({ className: clsx('professional_mypage_top_proffit_search_slide_tags_list skeleton', className) }, { children: dummies.map((v) => (_jsx(Skeleton, Object.assign({ className: 'tag_item', variant: 'rect' }, { children: _jsx("div", Object.assign({ className: 'item_inner' }, { children: _jsx(TagIcon, { className: 'item_icon gray' }) })) }), v.index))) })));
};
ProfessionalMyPageTopProffitSearchSlideTagsContentSkeleton.propTypes = {
    className: propStr(),
};
ProfessionalMyPageTopProffitSearchSlideTagsContentSkeleton.defaultProps = {
    className: '',
};
export default ProfessionalMyPageTopProffitSearchSlideTagsContentSkeleton;
